/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetMenuSectionsResponse } from '../../models/get-menu-sections-response';

export interface GetMenuSections$Params {
}

export function getMenuSections(http: HttpClient, rootUrl: string, params?: GetMenuSections$Params, context?: HttpContext): Observable<StrictHttpResponse<GetMenuSectionsResponse>> {
  const rb = new RequestBuilder(rootUrl, getMenuSections.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetMenuSectionsResponse>;
    })
  );
}

getMenuSections.PATH = '/client/menu';
